import { render } from "./ResetPassword.vue?vue&type=template&id=45460578"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=45460578&lang=css"

import exportComponent from "/home/ubuntu/apps/synergy-login/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__